@defer (on viewport) {
    <div class="leaderboard-root">
        <ng-container *ngIf="isLoading; else loadedBlock">
            <div class="scroll-section">
                <app-loading-indicator></app-loading-indicator>
            </div>
        </ng-container>

        <ng-template #loadedBlock>
            <div class="leaderboard-header" *ngIf="showPicker">
                <div class="filters-row">
                    <mat-form-field class="filter-select">
                        <mat-select name="follow-filter" [formControl]="playerFilter">
                            <mat-option *ngFor="let item of playerFilterOptions" [value]="item.value">
                                {{ item.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="filter-search">
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput type="text" [formControl]="playerSearch" [placeholder]="searchPlaceholder" />
                        <button *ngIf="playerSearch.value" mat-icon-button matSuffix aria-label="Clear search" (click)="clearSearch($event)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="last-updated">Last Updated At: {{ lastUpdatedDate | date: 'short' }}</div>
            </div>

            <div class="leaderboard-body">
                <ng-container *ngIf="showGenericEmpty || showAllFilteredEmpty; else hasDataOrFollowedEmpty">
                    <div class="empty-followed" [ngStyle]="showPicker ? {} : { 'margin-top': '6rem' }">
                        <img src="https://res.cloudinary.com/bleachr/image/upload/v1578685073/TennisONE/T1%20Icons/no-data.png" alt="" />
                        <h2>
                            <app-app-string key_name="golf.leaderboard.empty.title"></app-app-string>
                        </h2>
                        <p>
                            <app-app-string key_name="golf.leaderboard.empty.body"></app-app-string>
                        </p>
                    </div>
                </ng-container>

                <ng-template #hasDataOrFollowedEmpty>
                    <ng-container *ngIf="showNoLiveEmpty; else followedEmptyOrTable">
                        <div class="empty-followed">
                            <img src="https://res.cloudinary.com/bleachr/image/upload/v1578685073/TennisONE/T1%20Icons/no-data.png" alt="" />
                            <h3>
                                <app-app-string key_name="golf.leaderboard.empty.live.title"></app-app-string>
                            </h3>
                            <p>
                                <app-app-string key_name="golf.leaderboard.empty.live.body"></app-app-string>
                            </p>
                        </div>
                    </ng-container>

                    <ng-template #followedEmptyOrTable>
                        <ng-container *ngIf="showNoFollowedEmpty; else tableBlock">
                            <div class="empty-followed">
                                <img src="https://res.cloudinary.com/bleachr/image/upload/v1578685073/TennisONE/T1%20Icons/no-data.png" alt="" />
                                <h3>
                                    <app-app-string key_name="golf.leaderboard.empty.followed.title"></app-app-string>
                                </h3>
                                <p>
                                    <app-app-string key_name="golf.leaderboard.empty.followed.body"></app-app-string>
                                </p>
                            </div>
                        </ng-container>

                        <ng-template #tableBlock>
                            <div class="scroll-section" #scrollSection>
                                <table mat-table [dataSource]="activeDataSource" multiTemplateDataRows>
                                    <ng-container matColumnDef="pos">
                                        <th mat-header-cell *matHeaderCellDef style="background-color: #009778">
                                            <app-app-string key_name="golf.leaderboard.position"></app-app-string>
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.pos }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="player">
                                        <th mat-header-cell *matHeaderCellDef style="background-color: #009778">
                                            <app-app-string key_name="golf.leaderboard.player"></app-app-string>
                                        </th>

                                        <td mat-cell *matCellDef="let element">
                                            <div class="player-cell">
                                                <mat-icon class="follow-star" [ngClass]="{ followed: isFollowing(element) }" aria-hidden="true">
                                                    {{ isFollowing(element) ? 'star' : 'star_border' }}
                                                </mat-icon>

                                                <span class="player-name-text">
                                                    {{ element.playerName }}
                                                </span>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="tot">
                                        <th mat-header-cell *matHeaderCellDef style="background-color: #009778">
                                            <app-app-string key_name="golf.leaderboard.total"></app-app-string>
                                        </th>
                                        <td mat-cell *matCellDef="let element">{{ element.tot }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="thru">
                                        <th mat-header-cell *matHeaderCellDef style="background-color: #009778">
                                            <app-app-string key_name="golf.leaderboard.thru"></app-app-string>
                                        </th>
                                        <td mat-cell *matCellDef="let element">{{ element.thru }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="strokes">
                                        <th mat-header-cell *matHeaderCellDef style="background-color: #009778">
                                            <app-app-string key_name="golf.leaderboard.strokes"></app-app-string>
                                        </th>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element.totalStrokes ?? '-' }}
                                        </td>
                                    </ng-container>

                                    <ng-container *ngFor="let col of roundColumns; let idx = index" [matColumnDef]="col">
                                        <th
                                            mat-header-cell
                                            *matHeaderCellDef
                                            [ngClass]="{ 'current-round-col': currentRound === idx + 1 && !eventFinished }"
                                            style="background-color: #009778"
                                        >
                                            <ng-container [ngSwitch]="idx + 1">
                                                <app-app-string *ngSwitchCase="1" key_name="golf.rounds.one.short"></app-app-string>
                                                <app-app-string *ngSwitchCase="2" key_name="golf.rounds.two.short"></app-app-string>
                                                <app-app-string *ngSwitchCase="3" key_name="golf.rounds.three.short"></app-app-string>
                                                <app-app-string *ngSwitchCase="4" key_name="golf.rounds.four.short"></app-app-string>
                                                <span *ngSwitchDefault>R{{ idx + 1 }}</span>
                                            </ng-container>
                                        </th>

                                        <td mat-cell *matCellDef="let element" [ngClass]="{ 'current-round-col': currentRound === idx + 1 && !eventFinished }">
                                            {{ element.roundVals[idx] || '-' }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="expand">
                                        <th mat-header-cell *matHeaderCellDef aria-label="row actions" style="background-color: #009778">&nbsp;</th>
                                        <td mat-cell *matCellDef="let element" style="padding-right: 0; padding-left: 0">
                                            <button mat-icon-button aria-label="expand row" (click)="toggleExpand(element); $event.stopPropagation()">
                                                <mat-icon *ngIf="isExpanded(element)">do_not_disturb_on</mat-icon>
                                                <mat-icon *ngIf="!isExpanded(element)">add_circle</mat-icon>
                                            </button>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="expandedDetail">
                                        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
                                            <div class="player-score-detail" [@detailExpand]="isExpanded(element) ? 'expanded' : 'collapsed'">
                                                <ng-container *ngIf="isExpanded(element)">
                                                    <!-- HEADER: always shown -->
                                                    <section class="player-header">
                                                        <div>
                                                            <app-image
                                                                style="cursor: pointer;"
                                                                (click)="openPlayer(element.source.player)"
                                                                [display_flag]="true"
                                                                [player]="element.source.player"
                                                                [app_country_flag_width]="'2rem'"
                                                                [country_flag_left]="'4.6rem'"
                                                                [country_flag_top]="countryFlagTop"
                                                            ></app-image>
                                                        </div>

                                                        <div class="player-details-follow">
                                                            <div class="player-name">{{ element.source.player.first_name }} {{ element.source.player.last_name }}</div>

                                                            <div class="player-actions">
                                                                <button
                                                                    mat-stroked-button
                                                                    class="player-action-btn"
                                                                    (click)="handleFollow(element.source.player.id); $event.stopPropagation()"
                                                                >
                                                                    <ng-container *ngIf="isFollowing(element); else follow">Unfollow</ng-container>
                                                                    <ng-template #follow>Follow</ng-template>
                                                                </button>

                                                                @if (element.source.player.merchandise_url) {
                                                                    <button
                                                                        mat-stroked-button
                                                                        class="player-action-btn"
                                                                        (click)="openPlayerGear(element.source.player, $event)"
                                                                    >
                                                                        {{ merchandiseButtonLabel }}
                                                                    </button>
                                                                }
                                                            </div>
                                                        </div>
                                                    </section>

                                                    <!-- TABS: only if stats exist -->
                                                    <div class="scorecard-tabs" *ngIf="hasStats(element.source)">
                                                        <button
                                                            mat-stroked-button
                                                            class="tab-btn"
                                                            [class.active]="getSelectedTab(element) === 'scorecard'"
                                                            (click)="setSelectedTab(element, 'scorecard', $event)"
                                                        >
                                                            <app-app-string key_name="golf.scorecard.tab.scorecard"></app-app-string>
                                                        </button>

                                                        <button
                                                            mat-stroked-button
                                                            class="tab-btn"
                                                            [class.active]="getSelectedTab(element) === 'stats'"
                                                            (click)="setSelectedTab(element, 'stats', $event)"
                                                        >
                                                            <app-app-string key_name="golf.scorecard.tab.stats"></app-app-string>
                                                        </button>
                                                    </div>

                                                    <!-- CONTENT -->
                                                    <ng-container *ngIf="getSelectedTab(element) === 'scorecard' || !hasStats(element.source); else statsBlock">
                                                        <ng-container *ngIf="hasScorecardData(element.source)">
                                                            <app-score-card-details
                                                                #details
                                                                [score_card]="element"
                                                                [courses]="golfTour.courses"
                                                                [eventFinished]="eventFinished"
                                                                [currentRound]="currentRound"
                                                                [selectedRound]="getSelectedRound(element)"
                                                                (selectedRoundChange)="setSelectedRound(element, $event)"
                                                            ></app-score-card-details>

                                                            <app-sponsor-banner
                                                                *ngIf="details?.cards?.length && element.rowIndex % 2 === 1"
                                                                location="Golf Scorecard"
                                                                sponsor_key="golf-scorecard"
                                                                aspect_ratio="9:1"
                                                            ></app-sponsor-banner>
                                                        </ng-container>
                                                    </ng-container>

                                                    <ng-template #statsBlock>
                                                        <div class="stats-table-wrap">
                                                            <table class="stats-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th class="stats-hdr">
                                                                            <app-app-string key_name="golfstats.header.stat"></app-app-string>
                                                                        </th>

                                                                        <th class="stats-hdr" *ngFor="let col of roundColumns; let idx = index">
                                                                            <ng-container [ngSwitch]="idx + 1">
                                                                                <app-app-string *ngSwitchCase="1" key_name="golf.rounds.one.short"></app-app-string>
                                                                                <app-app-string *ngSwitchCase="2" key_name="golf.rounds.two.short"></app-app-string>
                                                                                <app-app-string *ngSwitchCase="3" key_name="golf.rounds.three.short"></app-app-string>
                                                                                <app-app-string *ngSwitchCase="4" key_name="golf.rounds.four.short"></app-app-string>
                                                                                <span *ngSwitchDefault>R{{ idx + 1 }}</span>
                                                                            </ng-container>
                                                                        </th>

                                                                        <th class="stats-hdr">
                                                                            <app-app-string key_name="golfstats.header.total"></app-app-string>
                                                                        </th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr *ngFor="let r of getStatsRows(element.source)">
                                                                        <td class="stat-name">
                                                                            <app-app-string [key_name]="r.labelKey"></app-app-string>
                                                                        </td>

                                                                        <td class="stat-val" *ngFor="let v of r.roundVals">
                                                                            {{ displayStat(v) }}
                                                                        </td>

                                                                        <td class="stat-val total">
                                                                            {{ displayStat(r.total) }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </ng-template>
                                                </ng-container>
                                            </div>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="let element; columns: columnsToDisplay"
                                        class="leaderboard-row"
                                        style="cursor: pointer"
                                        [attr.data-player-id]="element.player_id"
                                        [class.expanded-row]="isExpanded(element)"
                                        [ngClass]="{ 'delta-flash': isFlashing(element) }"
                                        (click)="toggleExpand(element)"
                                    ></tr>
                                    <tr mat-row *matRowDef="let element; columns: ['expandedDetail']; let i = index" class="detail-row"></tr>
                                </table>
                                <!-- CUT / WD / DQ section -->
                                <div class="cut-section" *ngIf="hasCutPlayers">
                                  <div class="cut-section-header">
                                    <app-app-string key_name="golf.leaderboard.cutplayers"></app-app-string>
                                  </div>

                                  <table mat-table [dataSource]="cutDataSource" multiTemplateDataRows>
                                    <!-- POS -->
                                    <ng-container matColumnDef="pos">
                                      <td mat-cell *matCellDef="let element">
                                        {{ element.pos }}
                                      </td>
                                    </ng-container>

                                    <!-- PLAYER -->
                                    <ng-container matColumnDef="player">
                                      <td mat-cell *matCellDef="let element">
                                        <div class="player-cell">
                                          <mat-icon class="follow-star" [ngClass]="{ followed: isFollowing(element) }" aria-hidden="true">
                                            {{ isFollowing(element) ? 'star' : 'star_border' }}
                                          </mat-icon>

                                          <span class="player-name-text">
                                            {{ element.playerName }}
                                          </span>
                                        </div>
                                      </td>
                                    </ng-container>

                                    <!-- TOT -->
                                    <ng-container matColumnDef="tot">
                                      <td mat-cell *matCellDef="let element">{{ element.tot }}</td>
                                    </ng-container>

                                    <!-- THRU -->
                                    <ng-container matColumnDef="thru">
                                      <td mat-cell *matCellDef="let element">{{ element.thru }}</td>
                                    </ng-container>

                                    <!-- STROKES -->
                                    <ng-container matColumnDef="strokes">
                                      <td mat-cell *matCellDef="let element">
                                        {{ element.totalStrokes ?? '-' }}
                                      </td>
                                    </ng-container>

                                    <!-- ROUNDS: R1..Rn -->
                                    <ng-container *ngFor="let col of roundColumns; let idx = index" [matColumnDef]="col">
                                      <td mat-cell *matCellDef="let element" [ngClass]="{ 'current-round-col': currentRound === idx + 1 && !eventFinished }">
                                        {{ element.roundVals[idx] || '-' }}
                                      </td>
                                    </ng-container>

                                    <!-- EXPAND -->
                                    <ng-container matColumnDef="expand">
                                      <td mat-cell *matCellDef="let element" style="padding-right: 0; padding-left: 0">
                                        <button mat-icon-button aria-label="expand row" (click)="toggleExpand(element); $event.stopPropagation()">
                                          <mat-icon *ngIf="isExpanded(element)">do_not_disturb_on</mat-icon>
                                          <mat-icon *ngIf="!isExpanded(element)">add_circle</mat-icon>
                                        </button>
                                      </td>
                                    </ng-container>

                                    <!-- EXPANDED DETAIL -->
                                    <ng-container matColumnDef="expandedDetail">
                                      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
                                        <div class="player-score-detail" [@detailExpand]="isExpanded(element) ? 'expanded' : 'collapsed'">
                                          <ng-container *ngIf="isExpanded(element)">
                                            <!-- HEADER: always shown -->
                                            <section class="player-header">
                                              <div>
                                                <app-image
                                                  style="cursor: pointer;"
                                                  (click)="openPlayer(element.source.player)"
                                                  [display_flag]="true"
                                                  [player]="element.source.player"
                                                  [app_country_flag_width]="'2rem'"
                                                  [country_flag_left]="'4.6rem'"
                                                  [country_flag_top]="countryFlagTop"
                                                ></app-image>
                                              </div>

                                              <div class="player-details-follow">
                                                <div class="player-name">{{ element.source.player.first_name }} {{ element.source.player.last_name }}</div>

                                                <div class="player-actions">
                                                  <button
                                                    mat-stroked-button
                                                    class="player-action-btn"
                                                    (click)="handleFollow(element.source.player.id); $event.stopPropagation()"
                                                  >
                                                    <ng-container *ngIf="isFollowing(element); else follow">Unfollow</ng-container>
                                                    <ng-template #follow>Follow</ng-template>
                                                  </button>

                                                  @if (element.source.player.merchandise_url) {
                                                    <button
                                                      mat-stroked-button
                                                      class="player-action-btn"
                                                      (click)="openPlayerGear(element.source.player, $event)"
                                                    >
                                                      {{ merchandiseButtonLabel }}
                                                    </button>
                                                  }
                                                </div>
                                              </div>
                                            </section>

                                            <!-- TABS: only if stats exist -->
                                            <div class="scorecard-tabs" *ngIf="hasStats(element.source)">
                                              <button
                                                mat-stroked-button
                                                class="tab-btn"
                                                [class.active]="getSelectedTab(element) === 'scorecard'"
                                                (click)="setSelectedTab(element, 'scorecard', $event)"
                                              >
                                                <app-app-string key_name="golf.scorecard.tab.scorecard"></app-app-string>
                                              </button>

                                              <button
                                                mat-stroked-button
                                                class="tab-btn"
                                                [class.active]="getSelectedTab(element) === 'stats'"
                                                (click)="setSelectedTab(element, 'stats', $event)"
                                              >
                                                <app-app-string key_name="golf.scorecard.tab.stats"></app-app-string>
                                              </button>
                                            </div>

                                            <!-- CONTENT -->
                                            <ng-container *ngIf="getSelectedTab(element) === 'scorecard' || !hasStats(element.source); else statsBlock">
                                              <ng-container *ngIf="hasScorecardData(element.source)">
                                                <app-score-card-details
                                                  #details
                                                  [score_card]="element"
                                                  [courses]="golfTour.courses"
                                                  [eventFinished]="eventFinished"
                                                  [currentRound]="currentRound"
                                                  [selectedRound]="getSelectedRound(element)"
                                                  (selectedRoundChange)="setSelectedRound(element, $event)"
                                                ></app-score-card-details>

                                                <app-sponsor-banner
                                                  *ngIf="details?.cards?.length && element.rowIndex % 2 === 1"
                                                  location="Golf Scorecard"
                                                  sponsor_key="golf-scorecard"
                                                  aspect_ratio="9:1"
                                                ></app-sponsor-banner>
                                              </ng-container>
                                            </ng-container>

                                            <ng-template #statsBlock>
                                              <div class="stats-table-wrap">
                                                <table class="stats-table">
                                                  <thead>
                                                    <tr>
                                                      <th class="stats-hdr">
                                                        <app-app-string key_name="golfstats.header.stat"></app-app-string>
                                                      </th>

                                                      <th class="stats-hdr" *ngFor="let col of roundColumns; let idx = index">
                                                        <ng-container [ngSwitch]="idx + 1">
                                                          <app-app-string *ngSwitchCase="1" key_name="golf.rounds.one.short"></app-app-string>
                                                          <app-app-string *ngSwitchCase="2" key_name="golf.rounds.two.short"></app-app-string>
                                                          <app-app-string *ngSwitchCase="3" key_name="golf.rounds.three.short"></app-app-string>
                                                          <app-app-string *ngSwitchCase="4" key_name="golf.rounds.four.short"></app-app-string>
                                                          <span *ngSwitchDefault>R{{ idx + 1 }}</span>
                                                        </ng-container>
                                                      </th>

                                                      <th class="stats-hdr">
                                                        <app-app-string key_name="golfstats.header.total"></app-app-string>
                                                      </th>
                                                    </tr>
                                                  </thead>

                                                  <tbody>
                                                    <tr *ngFor="let r of getStatsRows(element.source)">
                                                      <td class="stat-name">
                                                        <app-app-string [key_name]="r.labelKey"></app-app-string>
                                                      </td>

                                                      <td class="stat-val" *ngFor="let v of r.roundVals">
                                                        {{ displayStat(v) }}
                                                      </td>

                                                      <td class="stat-val total">
                                                        {{ displayStat(r.total) }}
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </div>
                                            </ng-template>
                                          </ng-container>
                                        </div>
                                      </td>
                                    </ng-container>

                                    <tr
                                      mat-row
                                      *matRowDef="let element; columns: columnsToDisplay"
                                      class="leaderboard-row"
                                      style="cursor: pointer"
                                      [attr.data-player-id]="element.player_id"
                                      [class.expanded-row]="isExpanded(element)"
                                      [ngClass]="{ 'delta-flash': isFlashing(element) }"
                                      (click)="toggleExpand(element)"
                                    ></tr>

                                    <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="detail-row"></tr>
                                  </table>
                                </div>
                            </div>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </div>
        </ng-template>
    </div>
} @placeholder {
    <div class="placeholder-loading">
        <app-loading-indicator></app-loading-indicator>
    </div>
} @loading (minimum 500ms) {
    <div class="placeholder-loading">
        <app-loading-indicator></app-loading-indicator>
    </div>
} @error {
    <p>Error while trying to load data</p>
}
